import { DIRHAM_PATH, DIRHAM_VIEWBOX } from './icons.gen';
import { formatAmount } from './amount';

/**
 * An amount with the UAE dirham symbol (needs css/dirham.css).
 * Other currencies show their ISO code before the number instead.
 */
export function Money({ value, currency = 'AED', decimals = 2 }: { value: number; currency?: string; decimals?: 0 | 2 }) {
  const n = formatAmount(value, { decimals });
  if (currency !== 'AED') {
    return (
      <span className="dhm" dir="ltr">
        {currency} {n}
      </span>
    );
  }
  return (
    <span className="dhm" dir="ltr">
      <span className="dh" role="img" aria-label="AED">
        <svg className="dh-s" viewBox={DIRHAM_VIEWBOX} aria-hidden="true" focusable="false">
          <path d={DIRHAM_PATH} />
        </svg>
      </span>
      {n}
    </span>
  );
}
